import dirk from "./dirk-beller.jpg";
import eric from "./eric-andersen.jpg";
import logoFrame from "./grundriss-schmiede-logo.png";
import kai from "./kai-koschella.jpg";
import violetta from "./violetta-kielpinski.jpg";

export { dirk, eric, kai, logoFrame, violetta };
